export default __webpack_public_path__ + "static/media/thumbnail.44abda10.webp";